export default __webpack_public_path__ + "static/media/nf-001.381c7d45.webp";